import {useSyncExternalStore} from 'react';

/**
 * L'établissement que le backend a RÉELLEMENT appliqué à la dernière réponse
 * (en-tête `X-Selected-Facility-Id`, posé par SetSelectedFacility).
 *
 * Ce n'est pas forcément celui demandé : si l'établissement consulté a été
 * supprimé, le backend retombe sur celui du compte. La pastille « Vue client »
 * se fie donc à cette valeur, pas au localStorage.
 */
export const EFFECTIVE_FACILITY_HEADER = 'x-selected-facility-id';

let effectiveFacilityId: number | null = null;
const listeners = new Set<() => void>();

export function recordEffectiveFacility(rawHeader: unknown): void {
    const id = Number(rawHeader);
    if (!Number.isInteger(id) || id <= 0 || id === effectiveFacilityId) {
        return;
    }
    effectiveFacilityId = id;
    listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function useEffectiveFacilityId(): number | null {
    return useSyncExternalStore(subscribe, () => effectiveFacilityId);
}
